import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { useCallback, useState } from 'react';

/** A compact, searchable report selector whose menu stays outside the widget's clipped content. */
const SpecialReportWidgetSelect = ({
  label,
  options = [],
  selectedValue,
  onSelect,
  isSearchable = true,
}) => {
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);
  // Use this control's document so menus also work when a widget is in a popout window.
  const attachContainer = useCallback((node) => {
    setMenuPortalTarget(node?.ownerDocument.body ?? null);
  }, []);

  return (
    <div ref={attachContainer} className="special-report-widget-select min-w-0">
      <BaseSelect
        label={label}
        isSearchable={isSearchable}
        maxMenuHeight={180}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 'var(--z-popover)' }) }}
        selectProps={{
          options,
          value: findSelectOption(options, selectedValue),
          onChange: (option) => onSelect(option?.value),
          isDisabled: options.length < 2,
          placeholder: `Select ${label.toLowerCase()}`,
          menuPortalTarget,
          menuPosition: 'fixed',
        }}
      />
    </div>
  );
};

export default SpecialReportWidgetSelect;
